import { Module } from "vuex";
import { RootState } from "../types";
import { CompanyState } from "./types";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";

export const state: CompanyState = {
  initial: null,
};

const namespaced: boolean = true;

export const company: Module<CompanyState, RootState> = {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
